import React from "react";
import AllVideoTestimonials from "../components/AllVideoTestimonials";
import TestimonialsTwo from "../components/TestimonialsTwo";
import InteractiveTestimonial from "../components/InteractiveTestimonial";
import ReviewsSection from "../components/ReviewsSection";

const TestimonialsScreen = () => {
  return (
    <div className="w-full h-full">
      {/* All Video Testimonials Section */}
      <AllVideoTestimonials />

      {/* Interactive Testimonials Section */}
      {/* <InteractiveTestimonial /> */}

      {/* Community Section */}
      <TestimonialsTwo />

      {/* Social Reviews Section */}
      <ReviewsSection />
    </div>
  );
};

export default TestimonialsScreen;
